import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BellIcon as BellIconOutline, UserCircleIcon as UserCircleIconOutline } from '@heroicons/react/24/outline';

const Navbar = ({ user, onLogout }) => {
  const location = useLocation();

  return (
    <nav className="bg-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/dashboard" className="text-xl font-bold text-indigo-600">EcomConfirm</Link>
          </div>

          <div className="hidden sm:flex sm:items-center">
            <Link 
              to="/dashboard" 
              className={`px-3 py-2 text-sm font-medium rounded-md ${
                location.pathname === '/dashboard' 
                  ? 'text-indigo-600 bg-indigo-50' 
                  : 'text-gray-500 hover:text-indigo-600'
              }`}
            >
              Tableau de bord
            </Link>
            <Link 
              to="/orders" 
              className={`ml-4 px-3 py-2 text-sm font-medium rounded-md ${
                location.pathname === '/orders' 
                  ? 'text-indigo-600 bg-indigo-50' 
                  : 'text-gray-500 hover:text-indigo-600'
              }`}
            >
              Commandes
            </Link>
            <Link 
              to="/messaging" 
              className={`ml-4 px-3 py-2 text-sm font-medium rounded-md ${
                location.pathname === '/messaging' 
                  ? 'text-indigo-600 bg-indigo-50' 
                  : 'text-gray-500 hover:text-indigo-600'
              }`}
            >
              Messagerie
            </Link>

            {/* User Menu */}
            <div className="ml-4 flex items-center space-x-4">
              <button
                onClick={onLogout}
                className="px-3 py-2 text-sm font-medium text-gray-500 hover:text-indigo-600"
              >
                Déconnexion
              </button>
              {user && (
                <div className="flex items-center space-x-2">
                  <UserCircleIconOutline className="h-8 w-8 text-gray-400" />
                  <span className="text-sm text-gray-700">{user.email}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
